import axios from 'axios'
import { TokenRegisterType } from './types'
import { StorageKeys } from '@/contexts/Auth/types'
import {
  handleLogoutEmbed,
  handleManyRequestsRefreshToken,
} from '@/utils/postMessages/handleLogoutEmbed'
import { applyAppTokenRefreshInterceptor } from '@conexasaude/apply-refresh-token'
import { env } from '@/constants/env'
import { ConexaResponseError } from '@/types'
import coreApi from './coreApi'

const hirAPI = axios.create({
  baseURL: env.VITE_APP_MS_HIR_API_URL,
})

export const tokenRegisterHirAPI: TokenRegisterType = token => {
  const interceptorId = hirAPI.interceptors.request.use(config => {
    if (!config.headers.authorization) {
      config.headers.authorization = `Bearer ${token}`
    }

    return config
  })

  return () => hirAPI.interceptors.request.eject(interceptorId)
}

const handleRefreshToken = async () => {
  const refreshToken = localStorage.getItem(StorageKeys?.refreshToken)
  const userId = localStorage.getItem(StorageKeys?.userId)

  const { data } = await coreApi.post('token/refresh', {
    usuario_id: userId,
    refreshToken: refreshToken,
    audience: 'WEB',
  })

  return data?.accessToken
}

applyAppTokenRefreshInterceptor({
  client: hirAPI,
  options: {
    shouldIntercept(error: ConexaResponseError) {
      return (
        error?.response?.status === 401 &&
        error?.response?.data?.msg?.includes('INVALID_ACCESS_TOKEN')
      )
    },
  },
  handleRefreshToken,
  onSuccess(accessToken) {
    tokenRegisterHirAPI(accessToken)
    localStorage.setItem(StorageKeys?.token, accessToken)
  },
  onError(error) {
    if (error?.response?.status === 429) {
      handleManyRequestsRefreshToken()
      return
    }

    if (error?.response?.status === 401) {
      localStorage.clear()
      handleLogoutEmbed()
    }
  },
})

export default hirAPI
